import React from "react";
import { X } from "lucide-react";
import { formatDate } from "../../../utils/tspFormat";

// The panel of the open state (shown over its state map). Every figure is the
// API's (per-state aggregates of the city-visit records); the city list is that
// state's points. A state with no visits says so — no numbers are made up.
export default function CoverageStatePanel({ detail, onSelectCity, onSelectJourney, onClose }) {
  if (!detail) return null;
  const currentLabels = detail.currentCities.map((city) => city.city_name || city.label);

  return (
    <section className="tsp-cov-state-panel" role="dialog" aria-modal="false" aria-labelledby="tsp-cov-state-title">
      <div className="tsp-cov-state-head">
        <h4 id="tsp-cov-state-title">{detail.name}</h4>
        <button type="button" className="tsp-cov-icon-btn" aria-label="Close the state map" onClick={onClose}>
          <X size={15} />
        </button>
      </div>

      {!detail.hasVisits ? (
        <p className="tsp-cov-note">No visits have been recorded in {detail.name} yet.</p>
      ) : (
        <>
          <dl className="tsp-cov-state-stats">
            <div>
              <dt>Visited places</dt>
              <dd>{detail.visitedCityCount}</dd>
            </div>
            <div>
              <dt>Journeys</dt>
              <dd>{detail.journeyCount}</dd>
            </div>
            <div>
              <dt>Current location</dt>
              <dd>{currentLabels.length ? currentLabels.join(", ") : "—"}</dd>
            </div>
          </dl>

          {detail.visitsWithoutCoordinates > 0 && (
            <p className="tsp-cov-note">
              {detail.visitsWithoutCoordinates} older visit{detail.visitsWithoutCoordinates === 1 ? " was" : "s were"} recorded without coordinates and {detail.visitsWithoutCoordinates === 1 ? "is" : "are"} not on the map.
            </p>
          )}

          {detail.cities.length > 0 && (
            <>
              <h5 className="tsp-cov-state-sub">Talukas / Towns on the map</h5>
              <ul className="tsp-cov-state-cities">
                {detail.cities.map((city) => (
                  <li key={city.locationId}>
                    <button type="button" className="tsp-cov-state-city" onClick={() => onSelectCity(city.locationId)}>
                      <span className={`tsp-cov-legend-dot tsp-cov-legend-dot--${city.current ? "current" : "visited"}`} aria-hidden="true" />
                      <span className="tsp-cov-state-city-name">{city.name}</span>
                      <span className="tsp-cov-state-city-meta">
                        {city.current ? "Current · " : ""}
                        {city.visitCount} visit{city.visitCount === 1 ? "" : "s"}
                        {city.lastVisit ? ` · ${formatDate(city.lastVisit)}` : ""}
                      </span>
                    </button>
                  </li>
                ))}
              </ul>
            </>
          )}

          {detail.journeys.length > 0 && (
            <>
              <h5 className="tsp-cov-state-sub">Routes</h5>
              <ul className="tsp-cov-state-journeys">
                {detail.journeys.map((journey) => (
                  <li key={journey.id}>
                    <button type="button" className="tsp-link-btn" onClick={() => onSelectJourney(journey.id)}>
                      {journey.journey_name}
                    </button>
                    {journey.temple_name && <span className="tsp-cov-state-city-meta"> · {journey.temple_name}</span>}
                  </li>
                ))}
              </ul>
            </>
          )}
        </>
      )}
    </section>
  );
}
